import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { EaseTable } from '../../../libs/EaseTable';
import { ContentCard, QuickTransferModal, BulkUploadModal, PaginationKaBaap } from '../../Common';
import { handleApiExceptions, generate_query_set, alertify, goTo } from '../../../app_methods';
import { getTransfersTableColumns, transfersTableFilterNodes } from './constants';
import { TransferRequest, BulkUploadBatch, Merchant } from '../../../models';
import { connect } from 'react-redux';
import { Menu, Dropdown, Icon, Descriptions, Badge, Button, message } from 'antd';
import { EaseDrawer } from '../../../libs/EaseDrawer';
import { TRANSFER_STATUS_TYPES } from '../../../constants';
import { Text4 } from '../../../styles';
import { TransferInfo } from './info';
import { CreatePermissionHoc, PermissionHoc } from '../../HOC';
import moment from 'moment';

const ApprovalFlowPermissableButton = PermissionHoc(Button, "APPROVAL_FLOW_READ", { is_component: true, fallbackComponent: null })

const TransfersList = (props) => {
    const [transfers, setTransfers] = useState([]);
    const [isTableLoading, setIsTableLoading] = useState(false);
    const [isCancelling, setIsCancelling] = useState(false);
    const [pagination, setPagination] = useState({
        pageSize: 15,
        current: 1,
        hasNext: true,
        showing: { from: 1, to: 15 }
    });
    const [filters, setFilters] = useState({});
    const [showTransferModal, seShowTransferModal] = useState(false);
    const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);
    const [showStatusInfoDrawer, setShowStatusInfoDrawer] = useState(false);
    const [showTransferInfoDrawer, setShowTransferInfoDrawer] = useState(false);
    const [selectedTransferRequest, setSelectedTransferRequest] = useState(false);
    const [virtualAccounts, setVirtualAccounts] = useState(props.current_user.virtual_accounts);
    const { batch_id, contact_id, beneficiary_id, beneficiary_account_name } = useParams();
    const [isDownloading, setIsDownloading] = React.useState(false);
    
    const prepFilters = (filters) => {
        let _filters = { ...filters };
        if (_filters.created_at && _filters.created_at.length) {
            _filters.created_at_start = _filters.created_at[0].format("YYYY-MM-DD");
            _filters.created_at_end = moment().isBefore(_filters.created_at[1])?moment().format("YYYY-MM-DD"):_filters.created_at[1].format("YYYY-MM-DD");
            delete _filters.created_at;
        }
        if (_filters.transfer_date && _filters.transfer_date.length) {
            _filters.transfer_date_start = _filters.transfer_date[0].format("YYYY-MM-DD");
            _filters.transfer_date_end = moment().isBefore(_filters.transfer_date[1])?moment().format("YYYY-MM-DD"):_filters.transfer_date[1].format("YYYY-MM-DD");
            delete _filters.transfer_date;
        }
        return _filters;
    };
    const fetchTransfers = async (_pagination = pagination, _filters = filters) => {
        if (!props.current_user.key) return;
        setIsTableLoading(true);
        const response = _filters.batch_id ?
            await BulkUploadBatch.fetch_transfers({ ...{ pageSize: _pagination.pageSize, current: _pagination.current }, ...prepFilters(_filters) })
            :
            await TransferRequest.list({ ...{ pageSize: _pagination.pageSize, current: _pagination.current, contact_id, beneficiary_id }, ...prepFilters(_filters) })
        if (!response.success) {
            setIsTableLoading(false);
            handleApiExceptions(response);
            return;
        }
        let queryset = generate_query_set(TransferRequest, response.data.results)
        queryset = queryset.map((transfer_request) => { return { ...transfer_request, is_submerchant:!!_filters.submerchant_id }})
        if (selectedTransferRequest.id) setSelectedTransferRequest(queryset.find(transferRequest => transferRequest.id == selectedTransferRequest.id));
        setTransfers(queryset);

        setPagination({ ..._pagination, ...response.data.pagination });
        setIsTableLoading(false);
    };

    const fetchVirtualAccounts = async (merchant_id=props.current_user.id) => {
        setVirtualAccounts([]);
        let merchant = new Merchant({id: merchant_id})
        const response = await merchant.list_virtual_accounts()
        if (!response.success) {
            return;
        }
        setVirtualAccounts(response.data.virtual_accounts)
    };

    const cancelTransfer = async (record) => {
        setIsCancelling(true);
        const response = await record.cancel();
        if (!response.success) {
            setIsCancelling(false);
            handleApiExceptions(response);
            return;
        }
        alertify("Success", "Transfer cancelled successfully.", "success");
        setIsCancelling(false);
        fetchTransfers();
    }

    const toggleTransferModal = () => {
        seShowTransferModal(!showTransferModal);
    };

    const toggleBulkUploadModal = () => {
        setShowBulkUploadModal(!showBulkUploadModal);
    };

    const toggleTransferInfoDrawer = (obj = {}) => {
        setSelectedTransferRequest(obj);
        setShowTransferInfoDrawer(!showTransferInfoDrawer);
    }

    const handleTableChange = (tableInfo) => {
        if (tableInfo.trigger == "columns") return;
        let _pagination = pagination;
        if (tableInfo.trigger == "filters") _pagination.current = 1;
        let _filters = tableInfo.filters;
        if(_filters?.submerchant_id != filters.submerchant_id){
            fetchVirtualAccounts(_filters.submerchant_id?_filters.submerchant_id:props.current_user.id);
        }
        setPagination(_pagination);
        setFilters(_filters);
        fetchTransfers(_pagination, _filters);
    };

    const onPageChange = (_pagination) => {
        setPagination({ ..._pagination });
        fetchTransfers({ ..._pagination }, filters);
    };


    const tableColumns = getTransfersTableColumns({ setShowStatusInfoDrawer: setShowStatusInfoDrawer });

    let filterNodes = transfersTableFilterNodes({
        merchant_payment_modes: props.current_user.payment_modes || [],
        virtual_accounts: virtualAccounts || [],
        contact_id, 
        beneficiary_id,
        beneficiary_account_name,
    }, props.current_user);

    if (batch_id) {
        filterNodes = transfersTableFilterNodes({
            merchant_payment_modes: props.current_user.payment_modes || [],
            virtual_accounts: virtualAccounts || [],
            batch_id: batch_id,
            contact_id, 
            beneficiary_id,
            beneficiary_account_name,
        }, props.current_user);
    }

    useEffect(() => {
        props.onChildMount();
        let _filters = { ...filters };
        if (batch_id) {
            filterNodes = transfersTableFilterNodes({
                merchant_payment_modes: props.current_user.payment_modes || [],
                batch_id: batch_id,
                contact_id, 
                beneficiary_id,
                beneficiary_account_name,
            }, props.current_user);
            _filters = { ..._filters, batch_id: batch_id };
        }
        let defaultFilters = {};
        filterNodes.forEach(f => defaultFilters[f.field] = f.defaultValue);
        _filters = { ..._filters, ...defaultFilters };
        setFilters({ ..._filters });
        fetchTransfers(pagination, { ..._filters });
    }, []);

    const downloadReport = async () => {
        setIsDownloading(true);
        const response = await TransferRequest.download_report({ ...prepFilters(filters)});
        if (!response.success) {
            setIsTableLoading(false);
            handleApiExceptions(response);
            return;
        }
        alertify(
            "Success",
            response?.data?.message || "Request generated Successfully",
            "confirm",
            {
                closable: true,
                cancelText: "Close",
                okText: "Go to Report Section",
                onOk: () => goTo(`/reports`, props.history),
                onCancel: () => { },
                icon: <Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" />
            }
        );
        setIsDownloading(false);
    };

    const hasSBIVirtualAccount = virtualAccounts?.some(acc => acc.provider_code === "SBI");
    const handleBulkClick = () => {
        if (hasSBIVirtualAccount) {
            message.warning("Bulk operations are not allowed for SBI.");
            return;
        }
        toggleBulkUploadModal();
    };
    const CreateButton = CreatePermissionHoc(
        { 
            create_permission: 'TRANSFERS_QUICK_INITIATE', 
            bulk_permission: 'TRANSFERS_BULK_UPLOAD' 
        }, 
        { 
            onCreateClick: toggleTransferModal, 
            onBulkClick: handleBulkClick, 
            createText: <><span className="mr-2" dangerouslySetInnerHTML={{ __html: `&#8377;` }} /> Instant Transfer</>, 
            bulkText: "Bulk Transfer", 
        }
    );
    


    return (
        <ContentCard className="p-3">
            <div className="w-100 d-flex justify-content-end">
                <CreateButton />
                {props.current_user.eta && <ApprovalFlowPermissableButton type="primary" style={{ marginLeft: "10px" }} ghost onClick={() => props.redirect('/approval-flow')}>Approval Flow</ApprovalFlowPermissableButton>}
            </div>
            <div>
                <EaseTable
                    rowKey="id"
                    loading={isTableLoading}
                    data={transfers}
                    columns={tableColumns}
                    fixedSelectable={!isMobile}
                    handleTableChange={handleTableChange}
                    filterNodes={filterNodes}
                    onRow={(record) => ({
                        onClick: () => {
                            toggleTransferInfoDrawer(record);
                        },
                    })}
                    downloadable={true}
                    onDownload={downloadReport}
                    isDownloading={isDownloading}
                />
                <PaginationKaBaap pageChange={onPageChange} pagination={pagination} />
            </div>
            <QuickTransferModal
                visible={showTransferModal}
                toggleTransferModal={toggleTransferModal}
                onSuccess={() => fetchTransfers(pagination, filters)}
            />
            <BulkUploadModal
                history={props.history}
                visible={showBulkUploadModal}
                toggleBulkUploadModal={toggleBulkUploadModal}
                onSuccess={() => fetchTransfers(pagination, filters)}
                type="transfer"
            />
            <EaseDrawer
                visible={showStatusInfoDrawer}
                onClose={() => setShowStatusInfoDrawer(false)}
                hideFooter
                title="Transfer Statuses"
                width={500}
            >
                <Descriptions bordered className="mt-3" size="small" layout="horizontal" column={1}>
                    {
                        Object.keys(TRANSFER_STATUS_TYPES).map((key, index) => {
                            return <Descriptions.Item label={<Badge color={TRANSFER_STATUS_TYPES[key].color} text={<Text4>{TRANSFER_STATUS_TYPES[key].label}</Text4>} />}>
                                {TRANSFER_STATUS_TYPES[key].description}
                            </Descriptions.Item>
                        })
                    }
                </Descriptions>
            </EaseDrawer>
            <TransferInfo
                visible={showTransferInfoDrawer}
                onClose={toggleTransferInfoDrawer}
                transferRequest={selectedTransferRequest}
                cancelTransfer={cancelTransfer}
                merchant={props.current_user}
                isCancelling={isCancelling}
                fetchTransfers={fetchTransfers}
                filters={filters}
                pagination={pagination}
            />


        </ContentCard>
    )
};

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
});

export default connect(mapStateToProps)(PermissionHoc(TransfersList, 'TRANSFERS_READ'));